export const icons = [
    '5-star-hotel',
    '500px',
    'addons',
    'address-book',
    'adjust',
    'aim',
    'air-balloon',
    'air-ticket',
    'airplane-alt',
    'alarm',
    'anchor',
    'angry',
    'apple',
    'apple-watch',
    'archive',
    'arrow-down',
    'arrow-left',
    'arrow-right',
    'arrow-up',
    'articulated-truck',
    'astonished',
    'at',
    'atom',
    'attachment',
    'audio',
    'auto-rickshaw',
    'automation',
    'award',
    'baby',
    'baby-backpack',
    'baby-cloth',
    'baby-milk-bottle',
    'baby-trolley',
    'backpack',
    'badge',
    'badminton-birdie',
    'badoo',
    'bag',
    'bag-alt',
    'baidu-tieba',
    'ball',
    'ban',
    'bank',
    'bank-alt',
    'bar-code',
    'barcode',
    'bars',
    'baseball',
    'baseballer',
    'basket',
    'basketball',
    'basketball-hoop',
    'bat',
    'battery-empty',
    'battery-full',
    'battery-half',
    'battery-low',
    'bbm-messenger',
    'beach',
    'beach-bed',
    'beaker',
    'bear-face',
    'beard',
    'bebo',
    'bed',
    'beer',
    'behance',
    'bell',
    'bell-alt',
    'beverage',
    'bicycle-alt-1',
    'bill',
    'bill-alt',
    'billboard',
    'billiard-ball',
    'bin',
    'binary',
    'binoculars',
    'birthday-cake',
    'black-board',
    'blogger',
    'bluetooth',
    'bomb',
    'book',
    'book-alt',
    'book-mark',
    'boot-alt-1',
    'bootstrap',
    'bowling',
    'bowling-alt',
    'box',
    'boy',
    'brainstorming',
    'brand-android-robot',
    'brand-apple',
    'brand-windows',
    'briefcase',
    'briefcase-1',
    'briefcase-2',
    'brightkite',
    'broken',
    'bucket',
    'bucket1',
    'bucket2',
    'bug',
    'building',
    'bulb-alt',
    'bullet',
    'bullhorn',
    'bullseye',
    'burger',
    'bus',
    'business-man',
    'businessman',
    'businesswoman',
    'butterfly',
    'cab',
    'cable-car',
    'calendar',
    'camera',
    'camera-alt',
    'camping-vest',
    'candy',
    'canoe',
    'car',
    'card',
    'caret-down',
    'caret-left',
    'caret-right',
    'caret-up',
    'cart',
    'cart-alt',
    'cassette',
    'cassette-player',
    'cat-alt-3',
    'cc',
    'certificate',
    'certificate-alt-1',
    'certificate-alt-2',
    'chair',
    'charging',
    'chart-bar-graph',
    'chat',
    'check',
    'check-alt',
    'check-circled',
    'checked',
    'cheer-leader',
    'chef',
    'chevron-down',
    'chevron-left',
    'chevron-right',
    'chevron-up',
    'children-care',
    'climbing',
    'clip',
    'clock-time',
    'close',
    'close-circled',
    'close-line',
    'close-line-circled',
    'close-line-squared',
    'close-line-squared-alt',
    'close-squared',
    'close-squared-alt',
    'cloud',
    'cloud-download',
    'cloud-refresh',
    'cloud-upload',
    'cloudapp',
    'code',
    'code-not-allowed',
    'coins',
    'comment',
    'company',
    'compass',
    'compass-alt',
    'computer',
    'concrete5',
    'confounded',
    'confused',
    'connection',
    'console',
    'contact-add',
    'contacts',
    'contrast',
    'copyright',
    'credit-card',
    'crop',
    'crown',
    'crying',
    'cube',
    'cubes',
    'cycling',
    'dashboard',
    'dashboard-web',
    'data',
    'database',
    'database-add',
    'database-locked',
    'database-remove',
    'delete',
    'delicious',
    'delivery-time',
    'designbump',
    'designfloat',
    'deviantart',
    'diamond',
    'dice',
    'dice-multiple',
    'digg',
    'direction-sign',
    'disc',
    'diskette',
    'dizzy',
    'document-folder',
    'dog',
    'dotcms',
    'download',
    'download-alt',
    'downloaded',
    'drag',
    'drag1',
    'drag2',
    'drag3',
    'dress',
    'dribbble',
    'dribble',
    'dropbox',
    'dumbbell',
    'earphone',
    'earth',
    'ebook',
    'ebuddy',
    'edit',
    'eject',
    'electron',
    'ello',
    'email',
    'ember',
    'envato',
    'envelope',
    'envelope-open',
    'eraser',
    'error',
    'evernote',
    'excavator',
    'exchange',
    'exclamation',
    'exclamation-circle',
    'exclamation-square',
    'exclamation-tringle',
    'exit',
    'expand',
    'expressionless',
    'external',
    'external-link',
    'eye',
    'eye-alt',
    'eye-blocked',
    'eye-dropper',
    'facebook',
    'facebook-messenger',
    'fast-delivery',
    'favourite',
    'fax',
    'feedburner',
    'female',
    'field',
    'file-alt',
    'file-fill',
    'files-stack',
    'film',
    'filter',
    'fire',
    'fire-alt',
    'fire-burn',
    'fire-truck',
    'fish',
    'flag',
    'flag-alt-1',
    'flag-alt-2',
    'flame-torch',
    'flash',
    'flash-drive',
    'flash-light',
    'flask',
    'flikr',
    'focus',
    'folder',
    'folder-open',
    'folkd',
    'foot-print',
    'football',
    'forward',
    'fountain-pen',
    'foursquare',
    'friendfeed',
    'funky-man',
    'game',
    'game-console',
    'game-controller',
    'game-pad',
    'garbage',
    'gear',
    'gear-alt',
    'gears',
    'ghost',
    'gift',
    'girl',
    'github',
    'glass',
    'globe',
    'globe-alt',
    'gnome',
    'goal',
    'golf',
    'golf-field',
    'golfer',
    'google-buzz',
    'google-hangouts',
    'google-map',
    'google-plus',
    'google-talk',
    'graduate',
    'graduate-alt',
    'graffiti',
    'grocery',
    'group',
    'group-students',
    'guiter',
    'hand',
    'handshake-deal',
    'hanger',
    'hard-disk',
    'hat-alt',
    'headphone-alt',
    'headphone-alt-1',
    'headphone-alt-3',
    'headphones',
    'heart',
    'heart-alt',
    'heart-eyes',
    'helicopter',
    'helmet',
    'high-heels',
    'hill',
    'hill-side',
    'history',
    'hockey',
    'holding-hands',
    'home',
    'horn',
    'hotel',
    'hotel-boy',
    'hour-glass',
    'hype-machine',
    'ice-skate',
    'id',
    'id-card',
    'imac',
    'image',
    'inbox',
    'indy-cart',
    'indy-grid',
    'indy-heart',
    'indy-heart-o',
    'indy-list',
    'indy-user',
    'infant-nipple',
    'infinite',
    'info',
    'info-circle',
    'info-square',
    'instagram',
    'institution',
    'instrument',
    'interface',
    'invisible',
    'ipad',
    'iphone',
    'ipod-nano',
    'island',
    'island-alt',
    'jacket',
    'jar',
    'jersey',
    'jewelery',
    'jewlery',
    'jumping',
    'kakaotalk',
    'karate',
    'key',
    'key-hole',
    'keyboard-alt',
    'kickstarter',
    'kid',
    'kids-scooter',
    'kik',
    'kitchen-chef',
    'kiwibox',
    'label',
    'lamp',
    'lamp-light',
    'laptop',
    'laughing',
    'layers',
    'layout',
    'leaf',
    'leaflet',
    'learn',
    'leg',
    'lego',
    'lens',
    'letter',
    'letterbox',
    'library',
    'license',
    'life-bouy',
    'life-buoy',
    'life-jacket',
    'life-ring',
    'light-bulb',
    'lighter',
    'lightning-ray',
    'like',
    'line',
    'line-height',
    'line-messenger',
    'link',
    'link-alt',
    'linkedin',
    'linux-mint',
    'lipstick',
    'list',
    'listening',
    'listine-dots',
    'listing-box',
    'listing-number',
    'live-messenger',
    'live-support',
    'livejournal',
    'location-arrow',
    'location-pin',
    'lock',
    'login',
    'logout',
    'lollipop',
    'long-drive',
    'look',
    'loop',
    'luggage',
    'luggage1',
    'lunch',
    'lungs',
    'macbook',
    'magento',
    'magic',
    'magic-alt',
    'magnet',
    'mail',
    'mail-box',
    'male',
    'man-in-glasses',
    'map',
    'map-pins',
    'maximize',
    'measure',
    'medal',
    'medal-sport',
    'medicine',
    'meeting-add',
    'meetme',
    'meetup',
    'mega-phone',
    'megaphone',
    'megaphone-alt',
    'memorial',
    'memory-card',
    'mic',
    'mic-mute',
    'micro-chip',
    'microphone-alt',
    'microscope-alt',
    'military',
    'mill',
    'minus',
    'minus-circle',
    'minus-square',
    'mixx',
    'mobile-phone',
    'molecule',
    'money',
    'money-bag',
    'moon',
    'mop',
    'motor-bike',
    'mouse',
    'movie',
    'mp3-player',
    'muffin',
    'multimedia',
    'muscle',
    'music',
    'music-alt',
    'music-disk',
    'music-note',
    'music-notes',
    'mustache',
    'mute-volume',
    'navigation',
    'navigation-menu',
    'nerd-smile',
    'network',
    'network-tower',
    'news',
    'newspaper',
    'newsvine',
    'nimbuss',
    'no-smoking',
    'not-allowed',
    'notebook',
    'notepad',
    'notification',
    'numbered',
    'octopus',
    'odnoklassniki',
    'olympic',
    'olympic-logo',
    'open-mouth',
    'opencart',
    'opposite',
    'optic',
    'options',
    'oscommerce',
    'package',
    'padding',
    'page',
    'paint',
    'panda',
    'pandora',
    'paper',
    'paper-plane',
    'paperclip',
    'papers',
    'pause',
    'paw',
    'paw-print',
    'pay',
    'pen-alt-4',
    'pen-nib',
    'penalty-card',
    'pencil',
    'pencil-alt-5',
    'penguin-linux',
    'people',
    'pestle',
    'phone',
    'phone-call',
    'phone-circle',
    'photobucket',
    'photography',
    'picasa',
    'picture',
    'pie-chart',
    'pine',
    'pinterest',
    'pixels',
    'pizza',
    'pizza-slice',
    'play',
    'play-alt-1',
    'play-alt-2',
    'play-alt-3',
    'play-pause',
    'plugin',
    'plus',
    'plus-circle',
    'plus-square',
    'polygonal',
    'portfolio',
    'power',
    'presentation',
    'presentation-alt',
    'prestashop',
    'price',
    'print',
    'psvita',
    'puzzle',
    'qik',
    'qq',
    'qr-code',
    'queen',
    'question',
    'question-circle',
    'question-square',
    'quill-pen',
    'quote-left',
    'quote-right',
    'racing-flag',
    'radio',
    'radio-mic',
    'rage',
    'random',
    'read-book',
    'read-book-alt',
    'readernaut',
    'record',
    'recycle',
    'reddit',
    'referee',
    'refresh',
    'refrigerator',
    'renren',
    'repair',
    'reply',
    'reply-all',
    'resize',
    'responsive',
    'result-sport',
    'retro-music-disk',
    'retweet',
    'rewind',
    'road',
    'robot',
    'rocket',
    'rolling-eyes',
    'royal',
    'rss',
    'rss-feed',
    'rugby',
    'runner',
    'sad',
    'safety',
    'safety-pin',
    'sail-boat',
    'sale-discount',
    'sandals-female',
    'sandals-male',
    'satellite',
    'school-bag',
    'school-bus',
    'scooter',
    'sea-plane',
    'search',
    'search-1',
    'search-2',
    'search-document',
    'search-folder',
    'search-job',
    'search-map',
    'search-property',
    'search-restaurant',
    'search-stock',
    'search-user',
    'send-mail',
    'server',
    'settings',
    'settings-alt',
    'share',
    'share-alt',
    'share-boxed',
    'shield',
    'ship',
    'shoe',
    'shopify',
    'shopping-cart',
    'sign-in',
    'sign-out',
    'signal',
    'silverstripe',
    'simple-smile',
    'site-map',
    'skiing-man',
    'skype',
    'slack',
    'slashdot',
    'slidshare',
    'slightly-smile',
    'smart-phone',
    'smirk',
    'smugmug',
    'snapchat',
    'soccer',
    'sofa',
    'song-notes',
    'sort',
    'sort-alt',
    'sound-wave',
    'sound-wave-alt',
    'soundcloud',
    'space',
    'spanner',
    'speech-comments',
    'speed-meter',
    'spinner',
    'spinner-alt-1',
    'spinner-alt-2',
    'spinner-alt-3',
    'spinner-alt-4',
    'spinner-alt-5',
    'spinner-alt-6',
    'spotify',
    'spreadsheet',
    'square',
    'ssl-security',
    'stack-exchange',
    'stack-overflow',
    'stamp',
    'star',
    'star-alt-1',
    'star-alt-2',
    'steam',
    'steering',
    'stock-mobile',
    'stop',
    'stopwatch',
    'street-view',
    'stuck-out-tongue',
    'student',
    'student-alt',
    'stumbleupon',
    'substitute',
    'support',
    'support-faq',
    'swimmer',
    't-shirt',
    'table-tennis',
    'tack-pin',
    'tag',
    'tagged',
    'tags',
    'tasks',
    'tasks-alt',
    'tea',
    'teacher',
    'technorati',
    'teddy-bear',
    'telegram',
    'telephone',
    'telescope',
    'tennis',
    'terminal',
    'test-bulb',
    'test-tube-alt',
    'thumbs-down',
    'thumbs-up',
    'tick-boxed',
    'tick-mark',
    'ticket',
    'tie',
    'tiktok',
    'tinder',
    'toggle-off',
    'toggle-on',
    'tools',
    'tools-alt-2',
    'touch',
    'toy-ball',
    'toy-cat',
    'toy-duck',
    'toy-elephant',
    'toy-hand',
    'toy-horse',
    'toy-lattu',
    'toy-train',
    'traffic-light',
    'train-line',
    'transparent',
    'travelling',
    'tree',
    'trello',
    'trophy-alt',
    'tumblr',
    'twitch',
    'twitter',
    'typo3',
    'ubercart',
    'ui-add',
    'ui-alarm',
    'ui-battery',
    'ui-block',
    'ui-bluetooth',
    'ui-brightness',
    'ui-browser',
    'ui-calendar',
    'ui-call',
    'ui-camera',
    'ui-cart',
    'ui-cell-phone',
    'ui-chat',
    'ui-check',
    'ui-clip',
    'ui-clip-board',
    'ui-clock',
    'ui-close',
    'ui-contact-list',
    'ui-copy',
    'ui-cut',
    'ui-delete',
    'ui-dial-phone',
    'ui-edit',
    'ui-email',
    'ui-file',
    'ui-fire-wall',
    'ui-flash-light',
    'ui-flight',
    'ui-folder',
    'ui-game',
    'ui-handicapped',
    'ui-home',
    'ui-image',
    'ui-laoding',
    'ui-lock',
    'ui-love',
    'ui-love-add',
    'ui-love-broken',
    'ui-love-remove',
    'ui-map',
    'ui-message',
    'ui-messaging',
    'ui-movie',
    'ui-music',
    'ui-music-player',
    'ui-mute',
    'ui-network',
    'ui-next',
    'ui-note',
    'ui-office',
    'ui-password',
    'ui-pause',
    'ui-play',
    'ui-play-stop',
    'ui-pointer',
    'ui-power',
    'ui-press',
    'ui-previous',
    'ui-rate-add',
    'ui-rate-blank',
    'ui-rate-remove',
    'ui-rating',
    'ui-record',
    'ui-remove',
    'ui-reply',
    'ui-rotation',
    'ui-rss',
    'ui-search',
    'ui-settings',
    'ui-social-link',
    'ui-tag',
    'ui-text-chat',
    'ui-text-loading',
    'ui-theme',
    'ui-timer',
    'ui-touch-phone',
    'ui-travel',
    'ui-unlock',
    'ui-user',
    'ui-user-group',
    'ui-v-card',
    'ui-video',
    'ui-video-chat',
    'ui-video-message',
    'ui-video-play',
    'ui-volume',
    'ui-weather',
    'ui-wifi',
    'ui-zoom-in',
    'ui-zoom-out',
    'unique-idea',
    'university',
    'unlock',
    'unlocked',
    'upload',
    'upload-alt',
    'usb',
    'usb-drive',
    'user',
    'user-female',
    'user-male',
    'users',
    'vaccine',
    'van',
    'vector-path',
    'verification-check',
    'viber',
    'viddler',
    'video',
    'video-alt',
    'video-cam',
    'video-clapper',
    'vimeo',
    'vine',
    'virb',
    'virtuemart',
    'vk',
    'volleyball',
    'volume-bar',
    'volume-down',
    'volume-mute',
    'volume-off',
    'volume-up',
    'waiter',
    'waiter-alt',
    'wall',
    'wall-clock',
    'wallet',
    'warning',
    'warning-alt',
    'watch',
    'water-drop',
    'web',
    'wechat',
    'weibo',
    'whatsapp',
    'wheelchair',
    'wifi',
    'wifi-alt',
    'wifi-router',
    'wink-smile',
    'woman-in-glasses',
    'women-bag',
    'world',
    'worried',
    'x',
    'xing',
    'yahoo',
    'yelp',
    'youku',
    'youtube',
    'youtube-play',
    'zencart',
    'zigzag',
    'zipped'
]
